



















import { Component, Prop, Vue, ComponentStyle, ComponentStyleDefinition } from "@zoovu/runner-browser-api";

@Component({})
export default class Modal extends Vue {
  @Prop()
  private status: false;

  @Prop()
  private type: "default";

  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;

  public onClose(): void {
    this.$emit("close-modal");
  }
}
